import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9998] p-4 animate-slide-up">
      <div className="container">
        <div className="glass-card p-4 md:p-6 flex flex-col md:flex-row items-center justify-between gap-4 border-primary/30">
          <div className="flex items-start gap-4">
            <div className="h-10 w-10 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0">
              <Cookie className="h-5 w-5 text-primary" />
            </div>
            <div className="text-sm text-muted-foreground">
              <p>
                Nous utilisons des cookies pour améliorer votre expérience sur notre site. 
                En continuant à naviguer, vous acceptez notre utilisation des cookies.{" "}
                <Link to="/mentions-legales" className="text-primary hover:underline">
                  En savoir plus
                </Link>
              </p>
            </div>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <Button variant="outline" size="sm" onClick={handleDecline}>
              Refuser
            </Button>
            <Button size="sm" onClick={handleAccept}>
              Accepter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
